import React, { useEffect, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import useFileDocuments from "../actions/useFileDocuments";
import SearchFIles from "./SearchFIles";
import CustomeButton from "~/components/Button";
import FolderListSection from "~/components/folder-list-section/FolderListSection";

const RequestFileDocuments = () => {
  const { id, service_id, type, request_type, request_id } = useParams();
  const location = useLocation();
  const {
    states,
    fileName,
    setFileName,
    rows,
    first,
    onPageChange,
    handleOpenRequest,
    handleCategoryFolderClick,
    setSelectedCategory,
  } = useFileDocuments({ id, service_id, type, request_type, request_id });

  // Auto-select category folder when navigating from "View in Folder"
  const appliedCategoryRef = useRef(false);
  useEffect(() => {
    const categoryCode = location.state?.categoryCode;
    if (
      !categoryCode ||
      appliedCategoryRef.current ||
      states?.categoryFoldersLoading ||
      !states?.folders?.length
    )
      return;
    const matchingFolder = states.folders.find(
      (f) => f.isCategoryFolder && f.code === categoryCode,
    );
    if (matchingFolder) {
      appliedCategoryRef.current = true;
      setSelectedCategory(matchingFolder);
    }
  }, [location.state, states?.folders, states?.categoryFoldersLoading]);

  const isRequestDetailView = request_id && states?.selectedRequest;
  const showCategoryFolders = isRequestDetailView && !states?.selectedCategory;
  const showCategoryFilteredTable =
    isRequestDetailView && states?.selectedCategory;
  const showTableWithoutCategories =
    isRequestDetailView &&
    !states?.selectedCategory &&
    !states?.categoryFoldersLoading &&
    (!states?.folders?.length || states.folders.length === 0);

  return (
    <>
      {showCategoryFolders && (
        <FolderListSection
          folders={states?.folders}
          loading={states?.categoryFoldersLoading}
          onFolderClick={handleCategoryFolderClick}
        />
      )}
      {(showCategoryFilteredTable || showTableWithoutCategories) && (
        <>
          <CustomeButton
            onClick={handleOpenRequest}
            label="Open Request"
            className="cancel-btn ml-auto mb-3"
            icon="pi pi-external-link"
            iconPos="right"
          />
          <SearchFIles
            fileName={fileName}
            setFileName={setFileName}
            additionaltag={{ entity: [states?.entity_detail?.name] }}
            states={states}
            first={first}
            rows={rows}
            onPageChange={onPageChange}
            categoryFilter={
              showCategoryFilteredTable ? states?.selectedCategory : undefined
            }
          />
        </>
      )}
      {!states.loading && !isRequestDetailView && (
        <>
          <CustomeButton
            onClick={handleOpenRequest}
            label="Open Request"
            className="cancel-btn ml-auto mb-3"
            icon="pi pi-external-link"
            iconPos="right"
          />
          <SearchFIles
            fileName={fileName}
            setFileName={setFileName}
            additionaltag={{ entity: [states?.entity_detail?.name] }}
            states={states}
            first={first}
            rows={rows}
            onPageChange={onPageChange}
          />
        </>
      )}
    </>
  );
};

export default RequestFileDocuments;
